<template>
  <div id="pareto-chart">
    <apexchart
      type="line"
      height="350"
      :options="chartOptions"
      :series="series"
      class="has-padding-1"
    />
  </div>
</template>

<script>

import VueApexCharts from "vue-apexcharts";
import GeneralService from "@/services/GeneralService";

export default {
  name: "pareto-chart",
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    costSection: {
      type: Object,
      required: true,
    },
  },
  computed: {
    costSectionCategories() {
      return this.costSection.sortedNames;
    },
    costSectionTotals() {
      return this.costSection.sortedCostTotals;
    },
    chartOptions() {
      return {
        chart: {
          height: 350,
          type: "bar",
          stacked: false,
        },
        colors: this.primaryColors,
        stroke: {
          width: [0, 1],
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
        },
        plotOptions: {
          bar: {
            columnWidth: "45%",
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: this.costSectionCategories,
        },
        yaxis: this.formattedYAxis,
        tooltip: this.formattedTooltip,
      };
    },
    formattedTooltip() {
      return {
        y: [
          {
            formatter: function(val) {
              return "$ " + GeneralService.dollarFormatted(val.toFixed(0));
            },
          },
          {
            formatter: function(val) {
              if (val) {
                return val.toFixed(0) + " %";
              }
            },
          },
        ],
      };
    },
    formattedYAxis() {
      return [
        {
          title: {
            text: "Cost of Defect ($)",
          },
          labels: {
            formatter: function(y) {
              return GeneralService.dollarFormatted(y.toFixed(0));
            },
          },
        },
        {
          opposite: true,
          title: {
            text: "Culmanative Percentage (%)",
          },
          labels: {
            formatter: function(y) {
              return Math.floor(y);
            },
          },
        },
      ];
    },
    paretoPoints() {
      const paretoPoints = this.costSection.sortedParetoPoints;
      return paretoPoints.map(point => Math.floor(point));
    },
    primaryColors() {
      return this.costSection.primaryColors;
    },
    series() {
      return [
        {
          name: "Total Costs",
          type: "column",
          data: this.costSectionTotals,
        },
        {
          name: "Pareto Analysis",
          type: "line",
          data: this.paretoPoints,
        },
      ];
    },
  },
};
</script>